import React from "react";
import { Link } from "react-router-dom";

const BookingSectionConfirm = (props) => {
    const { layout } = props;
    if (layout === 'vertical') {
        return <BookingSectionConfirmVertical {...props} />;
    } else if (layout === 'horizontal') {
        return <BookingSectionConfirmHorizontal {...props} />;
    }
};

const BookingSectionConfirmVertical = ({ currency, bookingRequest, bookingForm }) => {
    return (
        <div className="section-right">
            <div className="sticky-bar">
                <div className="card card-thinking card-outline-black border-0 mb-3 card-grey2 w-100">
                    <div className="card-body contact_form">
                        <div className="d-flex justify-content-between">
                            <h5 className="text-black font-all-round font-weight-600 font-size-20 pb-4">Booking request accepted</h5>
                        </div>
                        <div className="d-flex pb-4">
                            <span className="font-open-sans font-size-16 font-weight-400 text-black">
                                The host of this property has accepted your booking request. Click on the green button below to confirm your booking.
                            </span>
                        </div>
                        {/* Dates Section */}
                        <div className="d-flex justify-content-between pb-4">
                            <span className="font-open-sans font-size-16 font-weight-700 text-black">
                                Dates:
                            </span>
                            <span className="font-open-sans font-size-16 font-weight-400 text-black">
                                {`${bookingRequest.start_date} to ${bookingRequest.end_date}`}
                            </span>
                        </div>
                        <div className="d-flex justify-content-between pb-4">
                            <span className="font-open-sans font-size-16 font-weight-700 text-black">
                                Rate:
                            </span>
                            <span className="font-open-sans font-size-16 font-weight-400 text-black" dangerouslySetInnerHTML={{
                                __html: `${currency}${bookingRequest.property_price} per night`
                            }}/>
                        </div>
                        <div className="d-flex justify-content-between pb-4">
                            <span className="font-open-sans font-size-16 font-weight-700 text-black">
                                Guests:
                            </span>
                            <span className="font-open-sans font-size-16 font-weight-400 text-black">
                                {bookingRequest.guests}
                            </span>
                        </div>
                        <div className="d-flex justify-content-between pb-4">
                            <span className="font-open-sans font-size-16 font-weight-700 text-black">
                                Nights:
                            </span>
                            <span className="font-open-sans font-size-16 font-weight-400 text-black">
                                {bookingRequest.nights}
                            </span>
                        </div>
                        <div className="d-flex justify-content-between pb-4">
                            <span className="font-open-sans font-size-16 font-weight-700 text-black">
                                Accommodation Price:
                            </span>
                            <span className="font-open-sans font-size-16 font-weight-400 text-black" dangerouslySetInnerHTML={{
                                __html: `${currency}${bookingRequest.property_price * bookingRequest.nights}`
                            }}/>
                        </div>
                        <hr className="border-top-2"/>
                        <div className="d-flex justify-content-between py-4">
                            <span className="font-open-sans font-size-22 font-weight-700 text-black">Booking Fee</span>
                            <span className="font-open-sans font-size-22 font-weight-700 text-black" dangerouslySetInnerHTML={{
                                __html: `${currency}${(bookingRequest.nights * +bookingRequest.fee).toFixed(2)}`
                            }}/>
                        </div>
                        <div className="w-100">
                            <Link
                                className="btn btn-green font-open-sans font-size-16 font-weight-700 text-white float-md-right w-100 text-decoration-none d-block"
                                to={{ pathname: `/place/${bookingForm.placeId}/booking`, state: { bookingRequest } }}
                                dangerouslySetInnerHTML={{
                                    __html: `Pay ${currency}${(bookingRequest.nights * +bookingRequest.fee).toFixed(2)} to confirm booking`
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const BookingSectionConfirmHorizontal = ({ currency, bookingRequest, bookingForm }) => {
    return (
        <div className="card card-thinking card-outline-black border-0 mb-3 card-grey2 w-100">
            <div className="card-body contact_form d-flex">
                <div className="col-md-4 d-flex justify-content-between flex-wrap">
                    <div className="row pb-2 col-12">
                        <h5 className="text-black font-all-round font-weight-600 font-size-22">Booking request accepted</h5>
                    </div>
                    {/* Dates Section */}
                    <div className="d-flex justify-content-between row col-12">
                        <span className="font-open-sans font-size-16 font-weight-700 text-black">
                            Dates:
                        </span>
                        <span className="font-open-sans font-size-16 font-weight-400 text-black">
                            {`${bookingRequest.start_date} to ${bookingRequest.end_date}`}
                        </span>
                    </div>
                    <div className="d-flex justify-content-between row col-12">
                        <span className="font-open-sans font-size-16 font-weight-700 text-black">
                            Rate:
                        </span>
                        <span className="font-open-sans font-size-16 font-weight-400 text-black" dangerouslySetInnerHTML={{
                            __html: `${currency}${bookingRequest.property_price} per night`
                        }}/>
                    </div>
                    <div className="d-flex justify-content-between row col-12">
                        <span className="font-open-sans font-size-16 font-weight-700 text-black">
                            Guests:
                        </span>
                        <span className="font-open-sans font-size-16 font-weight-400 text-black">
                            {bookingRequest.guests}
                        </span>
                    </div>
                    <div className="d-flex justify-content-between row col-12">
                        <span className="font-open-sans font-size-16 font-weight-700 text-black">
                            Nights:
                        </span>
                        <span className="font-open-sans font-size-16 font-weight-400 text-black">
                            {bookingRequest.nights}
                        </span>
                    </div>
                </div>
                <div className="col-md-4 d-flex flex-wrap">
                    <div className="row col-12 align-items-end">
                        <span className="font-open-sans font-size-16 font-weight-400 text-black">
                            The host of this property has accepted your booking request. Click on the green button on the right to pay your booking fee and confirm your booking.
                        </span>
                    </div>
                </div>
                <div className="col-md-4 d-flex flex-wrap">
                    <div className="row col-12 justify-content-between">
                        <span className="font-open-sans font-size-24 font-weight-700 text-black">Booking Fee</span>
                        <span className="font-open-sans font-size-24 font-weight-400 text-black" dangerouslySetInnerHTML={{
                            __html: `${currency}${(bookingRequest.nights * +bookingRequest.fee).toFixed(2)}`
                        }}/>
                    </div>
                    <div className="row col-12 justify-content-center">
                        <span className="font-open-sans font-size-16 font-weight-400 text-black">
                            You pay only the booking fee to confirm.
                        </span>
                    </div>
                    <div className="row col-12 align-items-end">
                        <Link
                            className="btn btn-green font-open-sans font-size-16 font-weight-700 text-white float-md-right w-100 text-decoration-none d-block"
                            to={{ pathname: `/place/${bookingForm.placeId}/booking`, state: { bookingRequest } }}
                            dangerouslySetInnerHTML={{
                                __html: `Pay ${currency}${(bookingRequest.nights * +bookingRequest.fee).toFixed(2)} to confirm booking`
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingSectionConfirm;
